module.exports = __webpack_public_path__ + "img/zhejiang.7f8147eb.png";